import React from 'react';
import { AutocompleteInput, Datagrid, DateField, List, ShowButton, TextField } from 'react-admin';

const ManifestList = (props) => {
  const postFilters = [
    <AutocompleteInput
      source="category"
      choices={[
        { id: 'RECEIVED', name: 'Received' },
        { id: 'UPDATED', name: 'Updated' },
        { id: 'CLOSED', name: 'Closed' },
      ]}
    />,
  ];

  const CommentShowButton = ({ record }) => (
    <ShowButton basePath="/manifest" label="Show manifest" record={record} />
  );
  return (
    <List {...props} filters={postFilters} exporter={false}>
      <Datagrid>
        <TextField sortable={false} source="awb" />
        <TextField
          sortable={false}
          source="manifestNumber"
          label="Manifest number"
        />
        <TextField sortable={false} label="Status" source="status" />
        <TextField sortable={false} label="Total items" source="totalItems" />
        <TextField sortable={false} label="Airline" source="airlines" />
        <DateField label="Date" source="updatedAt" />
        <CommentShowButton />
      </Datagrid>
    </List>
  );
};

export default ManifestList;
